import { useQueryClient } from '@tanstack/react-query';

import { useMutation } from '@hooks/reactQuery';

import { useAppDispatch } from '@store/store';

import { setSnackbar } from '@slices/common';

import { createPreset } from '@api/configurationComparison';

import { ICreatePresetDTO } from '@interfaces/cmModule/dto/presetsDTO';
import { ITreeInitial } from '@interfaces/components/tree';

import { ESnackbarTypes } from '@enums/common';

import { CREATE_PRESET_TREE, PRESET_TREE } from '@constants/queryKeys';
import { responseMessages } from '@constants/responseMessages';

export const useMutateCreatePreset = (tree?: {
	moTree: ITreeInitial;
	treeIds: string;
}) => {
	const queryClient = useQueryClient();
	const dispatch = useAppDispatch();

	const {
		mutate: createTreePreset,
		isLoading: isLoadingCreateTreePreset,
	} = useMutation<ICreatePresetDTO>({
		mutationKey: [CREATE_PRESET_TREE],
		mutationFn: (data: ICreatePresetDTO) => createPreset({ ...data, dumpId: tree?.treeIds }),
		onSuccess: () => {
			dispatch(setSnackbar({
				message: responseMessages.createTreePresetSuccess,
				type: ESnackbarTypes.success,
			}));

			return [queryClient.invalidateQueries([PRESET_TREE])];
		},
	});

	return { createTreePreset, isLoadingCreateTreePreset };
};
